import Vue from 'vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { setAxiosHeaders } from '@/boot/axios';
// import { articleView } from '@/lib/http';

Vue.use(Vuex, VueCookies);
Vue.use(VueAxios, axios);

export default new Vuex.Store({
  state: {
    /**
     * Login
     */
    init: false,
    isLogged: false,
    name: '',
    nickname: '',
    email: '',
    token: '',
    role: '',

    /** Axios Response Modal Info */
    openModalInfo: false,
    modalInfoContent: 'test',
    urlRedirect: '',
    btnLink: '',

    /** Modal Confirm (Dual Buttons) */
    openModalConfirm: false,
    modalConfirmContent: '',
    confirmUrl: '',
    cancelUrl: '',
    confirmText: '確認',
    cancelText: '取消',

    /** Modal Identity */
    openModalIdentity: false,

    /** System Variables */
    sysVars: [],

    /** Order Category */
    orderType: '',

    newsPageType: '',

    currentTabName: '',
    /** 審核中, 未通過, 審核通過, 繳費失敗, 實體通路繳費, 繳費成功 */
    // applyStatus: '未通過',
    /** ATM轉帳, 超商代碼繳費 */
    applyPaymentType: '',

    modalHomeShow: true,

    // 首頁AD彈窗
    adLightBox: false,
  },
  mutations: {
    /**
     * Login
     */
    initLogin(state) {
      VueCookies.keys().forEach((key) => {
        state[key] = VueCookies.get(key);
      });
    },
    initSite(state) {
      state.init = true;
    },
    login(state, data) {
      Object.keys(data).forEach((key) => {
        state[key] = data[key];
      });
      state.isLogged = true;
    },
    logout(state) {
      state.isLogged = false;
      state.name = '';
      state.realname = '';
      state.role = 0;
      state.token = '';
      // state.level = '';
    },

    /** Axios Response Modal Info */
    toggleModalInfo(state, booleanStatus) {
      state.openModalInfo = booleanStatus;
    },
    updateModalInfoContent(state, message) {
      state.modalInfoContent = message;
    },
    assignUrlRedirect(state, url) {
      state.urlRedirect = url;
    },
    assignBtnLink(state, url) {
      state.btnLink = url;
    },

    /** Modal Confirm */
    toggleModalConfirm(state, booleanStatus) {
      state.openModalConfirm = booleanStatus;
    },
    updateModalConfirm(state, payload) {
      state.modalConfirmContent = payload.message || '';
      state.confirmUrl = payload.confirmUrl || '';
      state.cancelUrl = payload.cancelUrl || '';
      state.confirmText = payload.confirmText || '確認';
      state.cancelText = payload.cancelText || '取消';
    },

    /** Modal Identity */
    toggleModalIdentity(state, booleanStatus) {
      state.openModalIdentity = booleanStatus;
    },

    toggleModalHomeShow(state, status) {
      state.modalHomeShow = status;
    },

    /** System Variables */
    obtainSysVars(state, resArray) {
      state.sysVars = resArray;
    },

    /** Order Category */
    updateOrderType(state, name) {
      state.orderType = name;
    },

    /** News Page Type */
    updateNewsType(state, type) {
      state.newsPageType = type;
    },

    updateTabName(state, tabClicked) {
      state.currentTabName = tabClicked;
    },
    // updateApplyStatus(state, status) {
    //   state.applyStatus = status;
    // },
    updateApplyPaymentType(state, type) {
      state.applyPaymentType = type;
    },

    toggleADLightbox(state, status) {
      state.adLightBox = status;
    },
  },
  actions: {
    setSysVars({ commit }, resArray) {
      commit('obtainSysVars', resArray);
    },
    init({ commit }) {
      // console.log('init here', VueCookies.get('token'));
      // const cookieKeys = VueCookies.keys();
      if (VueCookies.isKey('token') && VueCookies.isKey('realname')) {
        commit('initLogin');
        setAxiosHeaders(VueCookies.get('token'));
      }
      setTimeout(() => {
        commit('initSite');
      }, 100);
    },
    login({ commit }, data) {
      commit('login', data);
      Object.keys(data).forEach((key) => {
        VueCookies.set(key, data[key]);
      });
    },
    logout({ commit }) {
      VueCookies.keys().forEach((cookie) => VueCookies.remove(cookie));
      commit('logout');
    },
    logoutBeforeLogin({ commit }) {
      VueCookies.keys().forEach((cookie) => {
        if (cookie !== 'courseInCart') {
          VueCookies.remove(cookie);
        }
      });
      commit('logout');
    },
    initModal({ commit }) {
      commit('assignUrlRedirect', '');
      commit('updateModalInfoContent', '');
      commit('assignBtnLink', '');
    },
    openModal({ commit }, payload) {
      if (payload.url) {
        commit('assignUrlRedirect', payload.url);
      }
      if (payload.btnLink) {
        commit('assignBtnLink', payload.btnLink);
      }
      commit('updateModalInfoContent', payload.message);
      commit('toggleModalInfo', true);
    },
    openConfirm({ commit }, payload) {
      commit('updateModalConfirm', payload);
      commit('toggleModalConfirm', true);
    },
  },
  modules: {
  },
  getters: {
    isAuthenticated(state) {
      return !!state.token && (state.level * 1 === 1 || state.level * 1 === 2);
    },
    hasToken(state) {
      return !!state.token;
    },
    modalInfoContent(state) {
      return state.modalInfoContent;
    },
    openModalInfo(state) {
      return state.openModalInfo;
    },
    modalConfirm(state) {
      return {
        open: state.openModalConfirm,
        message: state.modalConfirmContent,
        confirmUrl: state.confirmUrl,
        cancelUrl: state.cancelUrl,
        confirmText: state.confirmText,
        cancelText: state.cancelText,
      };
    },
    openModalIdentity(state) {
      return state.openModalIdentity;
    },
    homeAdInfo(state) {
      const { json } = state.sysVars.find(({ keyword }) => keyword === 'homeInfoDailog') || {};
      return json || { status: false, content: '' };
    },
    /**
     * 時數類別
     */
    hoursType(state) {
      let list = [];
      state.sysVars.forEach((obj) => {
        if (obj) {
          if (obj.keyword === 'hoursType') {
            list = obj.list || [];
          }
        }
      });
      return list;
    },
    /**
     * 活動類別
     */
    activityType(state) {
      let list = [];
      state.sysVars.forEach((obj) => {
        if (obj) {
          if (obj.keyword === 'fractionType') {
            list = obj.list || [];
          }
        }
      });
      return list;
    },
    /**
     * 學會訊息分類
     */
    newsType(state) {
      let list = [];
      state.sysVars.forEach((obj) => {
        if (obj) {
          if (obj.keyword === 'news') {
            list = obj.list || [];
          }
        }
      });
      return list;
    },
    /**
     * 活動類型
     */
    hostType(state) {
      let list = [];
      state.sysVars.forEach((obj) => {
        if (obj) {
          if (obj.keyword === 'hostType') {
            list = obj.list || [];
          }
        }
      });
      return list;
    },
    /**
     * 費用類型
     */
    feeType(state) {
      let list = [];
      state.sysVars.forEach((obj) => {
        if (obj) {
          if (obj.keyword === 'feeType') {
            list = obj.list || [];
          }
        }
      });
      return list;
    },
    /**
     * 繳費類型
     */
    payType(state) {
      let list = [];
      state.sysVars.forEach((obj) => {
        if (obj) {
          if (obj.keyword === 'payType') {
            list = obj.list || [];
          }
        }
      });
      return list;
    },
    /**
     * 餐食類型
     */
    eatType(state) {
      let list = [];
      state.sysVars.forEach((obj) => {
        if (obj) {
          if (obj.keyword === 'eatType') {
            list = obj.list || [];
          }
        }
      });
      return list;
    },
    /**
     * 餐食類型
     */
    foodType(state) {
      let list = [];
      state.sysVars.forEach((obj) => {
        if (obj) {
          if (obj.keyword === 'foodType') {
            list = obj.list || [];
          }
        }
      });
      return list;
    },
  },
});
